var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenderH(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1637",
    "data-name": "Groupe 1637",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.285,
    height: 63.636,
    viewBox: "0 0 22.285 63.636",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3214",
    "data-name": "Trac\\xE9 3214",
    d: "M14134.9,1902.144a6.907,6.907,0,1,1,6.906,6.908,6.906,6.906,0,0,1-6.906-6.908",
    transform: "translate(-14130.275 -1895.236)",
    fill: "#286ac7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3215",
    "data-name": "Trac\\xE9 3215",
    d: "M14145.685,1955.838h-7.55a1.58,1.58,0,0,1-1.691-1.216l-2.16-22.263,2.125-16.362a1.594,1.594,0,0,1,1.687-1.183h7.627a1.591,1.591,0,0,1,1.688,1.189l2.04,16.435-2.073,22.179a1.581,1.581,0,0,1-1.691,1.221",
    transform: "translate(-14130.818 -1892.202)",
    fill: "#286ac7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3216",
    "data-name": "Trac\\xE9 3216",
    d: "M14152.643,1933.641l-10.391,3.436-10.174-3.433a1.258,1.258,0,0,1-.857-1.193v-15.067a8.185,8.185,0,0,1,8.186-8.186h5.914a8.184,8.184,0,0,1,8.186,8.186v15.062a1.258,1.258,0,0,1-.863,1.2",
    transform: "translate(-14131.221 -1893.073)",
    fill: "#286ac7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderH);
export default __webpack_public_path__ + "static/media/gender_H.0cb60d70bb8bedbe8aabae2cc14ac0f2.svg";
export { ForwardRef as ReactComponent };